<template>
    <v-tabs
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">
        <v-tab key="Campi" ripple class="secondary-tab">
            Campi
        </v-tab>
        <v-tab key="Azioni" ripple class="secondary-tab">
            Azioni
        </v-tab>
        <v-tab key="Template" ripple class="secondary-tab">
            Template
        </v-tab>
        <v-tab key="Stampa" ripple class="secondary-tab">
            Stampa
        </v-tab>
        <v-tab key="Altro" ripple class="secondary-tab">
            Altro
        </v-tab>

        <v-tab-item class="background-1 pt-3 pb-1" key="Campi">

            <v-row class="ma-0 ">

                <v-col class="pa-0 pt-2" cols="12">
                    <fields-selector
                        model-def="trouble"
                        :totals="[{ label: 'Totali Ticket', infoTotals: 'info_totals' }]"
                    ></fields-selector>
                </v-col>

            </v-row>
            <v-tabs
                class="tabs-pill mt-4"
                height="34"
                background-color="background-1"
                slider-color="primary">
                <v-tab key="CampiInterventi" ripple class="secondary-tab">
                    Campi
                </v-tab>
                <v-tab key="AzioniInterventi" ripple class="secondary-tab">
                    Azioni
                </v-tab>

                <v-tab-item class="background-1 pt-3" key="CampiInterventi">
                    <v-row class="ma-0">

                        <v-col class="pa-0 pt-2" cols="12">
                            <fields-selector
                                model-def="intervention"
                                audit
                                :totals="[{ label: 'Totali Interventi', infoTotals: 'info_totals' }]"
                            ></fields-selector>
                        </v-col>

                    </v-row>
                </v-tab-item>

                <v-tab-item class="pb-offset background-1 pt-3" key="AzioniInterventi">
                    <v-row class="ma-0 pb-offset">

                        <v-col class="pa-0 pt-2" cols="12">
                            <actions-selector model-def="intervention" :actions-show="false"></actions-selector>
                        </v-col>

                    </v-row>
                </v-tab-item>
            </v-tabs>

            <v-tabs
                class="tabs-pill mt-4"
                height="34"
                background-color="background-1"
                slider-color="primary">
                <v-tab key="CampiProdottiInterventi" ripple class="secondary-tab">
                    Campi
                </v-tab>
                <v-tab key="AzioniProdottiInterventi" ripple class="secondary-tab">
                    Azioni
                </v-tab>

                <v-tab-item class="pb-offset background-1 pt-3" key="CampiProdottiInterventi">
                    <v-row class="ma-0 pb-offset">

                        <v-col class="pa-0 pt-2" cols="12">
                            <fields-selector
                                model-def="interventionproduct"
                                audit
                                :totals="[{ label: 'Totali Prodotti Interventi', infoTotals: 'info_totals' }]"
                            ></fields-selector>
                        </v-col>

                    </v-row>
                </v-tab-item>

                <v-tab-item class="pb-offset background-1 pt-3" key="AzioniProdottiInterventi">
                    <v-row class="ma-0 pb-offset">

                        <v-col class="pa-0 pt-2" cols="12">
                            <actions-selector model-def="interventionproduct" :actions-show="false"></actions-selector>
                        </v-col>

                    </v-row>
                </v-tab-item>
            </v-tabs>

        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Azioni">

            <v-row class="ma-0">

                <v-col class="pa-0 pt-2" cols="12">
                    <actions-selector
                        model-def="trouble"
                    ></actions-selector>
                </v-col>

            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Template">
            <v-row class="ma-0">
                <v-col class="pa-0" cols="12">
                    <crud
                        title='Template Stato Ticket'
                        action-icon='dynamic_feed'
                        model-def='templates-trouble'
                        action-position='absolute'
                    ></crud>
                </v-col>
            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Stampa">
            <v-row class="ma-0">
                <tickets-print></tickets-print>
            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Altro">
            <v-row class="ma-0">
                <tickets-options></tickets-options>
            </v-row>
        </v-tab-item>

    </v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import TicketsPrint from '@/components/modules/tickets/settings/TicketsPrint'
import TicketsOptions from '@/components/modules/tickets/settings/TicketsOptions'

	export default {
		name:'tickets-settings',
        components: {
            TicketsPrint,
				FieldsSelector,
				ActionsSelector,
            TicketsOptions,
        },
	}
  </script>
